import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import classReducer from './classSlice';

export const store = configureStore({
  reducer: {
    authentication: authReducer,
    school_classes: classReducer,
  },
});
